import {
    ConsentLevel,
    ScriptLoadResult,
    useScriptWithConsent,
} from '@news-mono/web-common'
import React from 'react'
import { LoggerContext } from '../../../diagnostics/LoggerContext'
import { ConsentFallback } from '../../../tracking/ConsentFallback/ConsentFallback'
import { TextLink } from '../../../typography/TextLink/TextLink'
import { OEmbedResult } from '../helpers/oembed'

export interface TikTokEmbedProps {
    link: string
}

export const TikTokScript = 'https://www.tiktok.com/embed.js'

export const TikTokEmbed: React.FC<TikTokEmbedProps> = ({ link }) => {
    const logger = React.useContext(LoggerContext)

    const [tikTokHtml, setTikTokHtml] = React.useState('')

    const [result, error] = useScriptWithConsent({
        consentMet: {
            src: TikTokScript,
        },
        consentRequiredLevel: ConsentLevel.All,
    })

    React.useEffect(() => {
        async function getTikTokOembed() {
            try {
                const tikTokUrl = encodeURIComponent(link)

                // New Oembed api - omit the script
                const graphRequest = await fetch(
                    `https://www.tiktok.com/oembed?url=${tikTokUrl}`,
                )

                const tikTokResp = (await graphRequest.json()) as OEmbedResult

                const html = tikTokResp.html

                if (html) {
                    setTikTokHtml(html)
                }
            } catch (error) {
                logger.debug({ error, link }, 'Error loading tikTok post')
            }
        }
        getTikTokOembed()
    }, [link, error, logger])

    if (result === ScriptLoadResult.NotConsented) {
        return <ConsentFallback />
    }

    if (result === ScriptLoadResult.Failed) {
        return (
            <TextLink href={link} openInNewWindow={true}>
                View TikTok Post
            </TextLink>
        )
    }

    if (!tikTokHtml || result === ScriptLoadResult.Loading) {
        return (
            <TextLink href={link} openInNewWindow={true}>
                Loading TikTok Post
            </TextLink>
        )
    }

    if (tikTokHtml) {
        return (
            <div
                dangerouslySetInnerHTML={{
                    __html: tikTokHtml,
                }}
            />
        )
    }
    return null
}

export default TikTokEmbed
